import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import VisitTracker from './components/VisitTracker';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import AdminLogin from './pages/Admin/Login';
import AdminLayout from './pages/Admin/AdminLayout';
import AdminDashboard from './pages/Admin/Dashboard';
import Analytics from './pages/Admin/Analytics';
import LeadManagement from './pages/Admin/LeadManagement';
import CustomerManagement from './pages/Admin/CustomerManagement';
import './App.css';

// Component to handle admin subdomain routing
function AdminSubdomainHandler() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const isAdminSubdomain = window.location.hostname === 'admin.fishmanhealth.com' || 
                            window.location.hostname === 'admin.fishmanmanhealth.com' ||
                            window.location.hostname.includes('admin');
    
    if (isAdminSubdomain) {
      // On admin subdomain, redirect root to admin login
      if (location.pathname === '/') {
        const token = localStorage.getItem('token');
        if (token) {
          navigate('/dashboard', { replace: true });
        } else {
          navigate('/login', { replace: true });
        }
      }
    }
  }, [navigate, location.pathname]);

  return null;
}

function App() {
  const isAdminSubdomain = window.location.hostname === 'admin.fishmanhealth.com' || 
                          window.location.hostname === 'admin.fishmanmanhealth.com' ||
                          window.location.hostname.includes('admin');

  return (
    <Router>
      <div className={`App ${isAdminSubdomain ? 'admin-app' : 'public-app'}`}>
        <AdminSubdomainHandler />
        
        <main className={`main-content ${isAdminSubdomain ? 'admin-main' : 'fh-public-main'}`}>
          <Routes>
            {isAdminSubdomain ? (
              // Admin subdomain routes
              <>
                <Route path="/login" element={
                  <>
                    <VisitTracker page="admin-login" />
                    <AdminLogin />
                  </>
                } />
                <Route path="/dashboard" element={
                  <>
                    <VisitTracker page="admin-dashboard" />
                    <AdminLayout>
                    <AdminDashboard />
                    </AdminLayout>
                  </>
                } />
                <Route path="/analytics" element={
                  <>
                    <VisitTracker page="admin-analytics" />
                    <AdminLayout>
                      <Analytics />
                    </AdminLayout>
                  </>
                } />
                <Route path="/leads" element={
                  <>
                    <VisitTracker page="admin-leads" />
                    <AdminLayout>
                    <LeadManagement />
                    </AdminLayout>
                  </>
                } />
                <Route path="/customers" element={
                  <>
                    <VisitTracker page="admin-customers" />
                    <AdminLayout>
                      <CustomerManagement />
                    </AdminLayout>
                  </>
                } />
                <Route path="/" element={
                  <>
                    <VisitTracker page="admin-home" />
                    <AdminLogin />
                  </>
                } />
                {/* Fallback route for any unmatched admin paths */}
                <Route path="*" element={
                  <>
                    <VisitTracker page="admin-login" />
                    <AdminLogin />
                  </>
                } />
              </>
            ) : (
              // Main site routes
              <>
                <Route path="/" element={
                  <>
                    <VisitTracker page="home" />
                    <Home />
                  </>
                } />
                <Route path="/about" element={
                  <>
                    <VisitTracker page="about" />
                    <About />
                  </>
                } />
                <Route path="/contact" element={
                  <>
                    <VisitTracker page="contact" />
                    <Contact />
                  </>
                } />
                <Route path="/admin" element={
                  <>
                    <VisitTracker page="admin-login" />
                    <AdminLogin />
                  </>
                } />
                <Route path="/admin/dashboard" element={
                  <>
                    <VisitTracker page="admin-dashboard" />
                    <AdminLayout>
                    <AdminDashboard />
                    </AdminLayout>
                  </>
                } />
                <Route path="/admin/analytics" element={
                  <>
                    <VisitTracker page="admin-analytics" />
                    <AdminLayout>
                      <Analytics />
                    </AdminLayout>
                  </>
                } />
                <Route path="/admin/leads" element={
                  <>
                    <VisitTracker page="admin-leads" />
                    <AdminLayout>
                    <LeadManagement />
                    </AdminLayout>
                  </>
                } />
                <Route path="/admin/customers" element={
                  <>
                    <VisitTracker page="admin-customers" />
                    <AdminLayout>
                      <CustomerManagement />
                    </AdminLayout>
                  </>
                } />
                {/* Fallback route for main site */}
                <Route path="*" element={
                  <>
                    <VisitTracker page="home" />
                    <Home />
                  </>
                } />
              </>
            )}
          </Routes>
        </main>
        
      </div>
    </Router>
  );
}

export default App;
